import {
  Beaker,
  Landmark,
  BookOpen,
  Sparkles,
} from "lucide-react";

export const YOUTUBE_URL = "https://www.youtube.com/@ATFQ-pcast";
export const X_URL = "https://x.com/ATFQ_Pcast";
export const X_HANDLE = "@ATFQ_Pcast";
export const BLUESKY_URL = "https://bsky.app/profile/atfq-pcast.bsky.social";
export const BLUESKY_HANDLE = "@atfq-pcast.bsky.social";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61586256301274";
export const ATFQ_DOMAIN = "atfqpod.com";
export const ATFQ_HOME_URL = "https://atfqpod.com";
export const ATFQ_CONTACT_EMAIL = "atfq.pcast@gmail.com";

export const ATFQ_BILLBOARD =
  "https://customer-assets.emergentagent.com/job_aviation-integrity/artifacts/nrjutw5m_Gemini_Generated_Image_x02n8ix02n8ix02n.webp";

export const ATFQ_LOGO =
  "https://customer-assets.emergentagent.com/job_aviation-integrity/artifacts/emcpu9jb_generated-image-2026-01-18-16-16-51.1280pix.no%20background.png";

export const SUBSCRIBE_LINKS = [
  { key: "youtube", label: "YouTube", href: YOUTUBE_URL, live: true },
  { key: "spotify", label: "Spotify", href: "#", live: false },
  { key: "apple", label: "Apple Podcasts", href: "#", live: false },
  { key: "rss", label: "RSS Feed", href: "#", live: false },
];

export const PILLARS = [
  {
    key: "science",
    Icon: Beaker,
    title: "Science",
    body: "Stripping away speculation to focus on empirical evidence.",
  },
  {
    key: "politics",
    Icon: Landmark,
    title: "Politics",
    body: "Dissecting institutional narratives and demanding accountability.",
  },
  {
    key: "philosophy",
    Icon: BookOpen,
    title: "Philosophy",
    body: "Challenging ethical frameworks and societal structures.",
  },
  {
    key: "religion",
    Icon: Sparkles,
    title: "Religion",
    body: "Analyzing belief systems with rigorous intellectual scrutiny.",
  },
];

export const CONTENT_PLAN = [
  {
    key: "postmortem",
    label: "Episode Drop · Coming Soon",
    title: "The Post-Mortem",
    body: "A transparent, data-driven breakdown of an independent run — signature math, systemic hurdles, and what it says about local voter choice.",
  },
  {
    key: "d5segment",
    label: "Recurring Segment",
    title: "The Georgia Case Files",
    body: "How national trends land locally — a running pulse on Georgia governance, from Henry County zoning to state-wide policy, with the same analytical scrutiny ATFQ brings to every topic.",
  },
  {
    key: "debates",
    label: "On-Air Format",
    title: "Local Debates · Unscripted",
    body: "Invite local candidates and officials on-mic for the raw, transparent interviews you won't find in legacy local media.",
  },
];
